const { addActions } = require('js-data-http')

let mapper_options = {
  endpoint: 'notes',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      },
      retailer: {
        foreignKey: 'retailer_id',
        localField: 'retailer'
      },
      user: {
        foreignKey: 'user_id',
        localField: 'user'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('note', mapper_options)

  addActions({
    publish: {
      pathname: 'publish',
      method: 'PUT'
    },

    unpublish: {
      pathname: 'unpublish',
      method: 'PUT'
    }
  })(mapper)
}
